import { CurrencyFormatter } from 'shared/lib';
import { pluralizeDays, pluralizeMonths } from 'shared/lib/pluralize';

import { EMPTY_SHILS } from '../constants';

export const getFormattedValues = ({ period, amount, snils }: { period?: number; amount?: number; snils?: string }) => {
  if (!period || !amount) {
    return {};
  }

  const isDaysPeriods = amount && amount < 100000;

  const postfix = isDaysPeriods ? pluralizeDays(period) : pluralizeMonths(period);

  const formattedPeriod = `${period} ${postfix}`;
  const formattedAmount = CurrencyFormatter.formatCurrency(amount);
  const formattedSnils = EMPTY_SHILS !== snils && !snils?.includes('_') ? snils : '';

  return {
    period: formattedPeriod,
    amount: formattedAmount,
    snils: formattedSnils,
  };
};
